import { useQuery } from '@tanstack/react-query';

import { fetchAllWorkspaceMembersPages } from '@/core/lib/workspace-members-fetch-all';
import {
  type WorkspaceMembersRosterPurpose,
  workspaceMembersQueryKeys,
} from '@/core/query-keys/workspace-members-query-keys';

/**
 * Shared full-roster query for leads filters, timeline, and event forms.
 */
export function useWorkspaceMembersRoster(
  workspaceId: string | undefined,
  purpose: WorkspaceMembersRosterPurpose,
  options?: { enabled?: boolean; staleTime?: number },
) {
  return useQuery({
    queryKey: workspaceId
      ? workspaceMembersQueryKeys.roster(workspaceId, purpose)
      : (['workspace-members', 'none', purpose] as const),
    queryFn: async () => {
      if (!workspaceId) return [];
      return fetchAllWorkspaceMembersPages(workspaceId);
    },
    enabled: (options?.enabled ?? true) && !!workspaceId,
    staleTime: options?.staleTime,
  });
}
